import { frozen } from "mobx-keystone";
import { Cubby } from "../Cubby";
import { notifyIfFirstItemChanged } from "../../helpers/notifications";

export const updateCubbyErrors = (cubby: Cubby, newCubbyErrors: any) => {
  const doNotNotifyStringBlacklist = ["Error connecting to peer"];
  const doNotNotifySubstringBlacklist = ["Error getting fee estimates"];

  // if the first item in the lists's description contains text from the blacklist
  /// skip the notififfirfstitemchange function
  if (
    cubby.cubbyErrors &&
    cubby.cubbyErrors.data[0] &&
    doNotNotifyStringBlacklist.includes(cubby.cubbyErrors.data[0].description)
  ) {
    return;
  }

  if (
    cubby.cubbyErrors &&
    cubby.cubbyErrors.data[0] &&
    doNotNotifySubstringBlacklist.some((substring) =>
      cubby.cubbyErrors.data[0].description.includes(substring)
    )
  ) {
    console.log("return because error substring");
    return;
  }

  console.log(
    "will notify if first item changed",
    cubby.cubbyErrors,
    newCubbyErrors
  );
  notifyIfFirstItemChanged(
    newCubbyErrors,
    cubby.cubbyErrors ? cubby.cubbyErrors.data : [],
    (item) => item.description,
    (item) => item.stamp,
    "Error",
    (item) => item.description,
    "red"
  );
  cubby.cubbyErrors = frozen(newCubbyErrors);

  // Update the cubbyErrors with the new errors
};

export const addNewErrorAndUpdateCubbyErrors = (
  cubby: Cubby,
  description: string
) => {
  // Get the current Unix timestamp
  const unixTimestamp = Math.floor(Date.now() / 1000);

  // Create a new error object
  const newError = {
    description: description,
    stamp: unixTimestamp,
  };

  // Get the current errors
  let updatedErrors = cubby.cubbyErrors ? [...cubby.cubbyErrors.data] : [];

  // Add the new error to the front of the existing errors
  updatedErrors.unshift(newError);

  // Update the cubbyErrors with the new error list
  cubby.updateCubbyErrors(updatedErrors);
};
